import { motion } from "framer-motion";

// Scroll-reveal wrapper — fades + rises children into view once.
export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

// Masked, line-by-line hero reveal. Pass an array of lines.
export function MaskedLines({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.15 }) {
    return (
        <span className={className} aria-label={lines.join(" ")}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden">
                    <motion.span
                        className={`block ${lineClassName}`}
                        initial={{ y: "110%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 0.9, delay: delay + i * stagger, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}

// Slow editorial marquee.
export function Marquee({ items, className = "" }) {
    const row = [...items, ...items];
    return (
        <div className={`overflow-hidden whitespace-nowrap ${className}`} data-testid="marquee">
            <motion.div
                className="inline-flex gap-10 will-change-transform"
                animate={{ x: ["0%", "-50%"] }}
                transition={{ duration: 28, ease: "linear", repeat: Infinity }}
            >
                {row.map((it, i) => (
                    <span key={i} className="inline-flex items-center gap-10">
                        <span>{it}</span>
                        <span className="text-aq-gold">✦</span>
                    </span>
                ))}
            </motion.div>
        </div>
    );
}
